import React, { useEffect, useState } from 'react';
export function CompactCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 49,
    seconds: 4
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newS = prev.seconds - 1;
        let newM = prev.minutes;
        let newH = prev.hours;
        if (newS < 0) {
          newS = 59;
          newM -= 1;
        }
        if (newM < 0) {
          newM = 59;
          newH -= 1;
        }
        return {
          hours: newH,
          minutes: newM,
          seconds: newS
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const Unit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-367">
      <div className="bg-brand-dark border border-brand-orange/30 rounded-md px-3 py-1.5 md:px-4 md:py-2 min-w-[56px] md:min-w-[64px]" data-id="element-368">
        <span className="font-display text-2xl md:text-3xl text-brand-orange leading-none tabular-nums" data-id="element-369">
          {fmt(value)}
        </span>
      </div>
      <span className="text-[9px] md:text-[10px] font-bold text-brand-muted uppercase tracking-widest mt-1.5" data-id="element-370">
        {label}
      </span>
    </div>;
  return <div className="flex items-center gap-1.5 md:gap-2" data-id="element-371">
      <Unit value={timeLeft.hours} label="Horas" data-id="element-372" />
      <span className="font-display text-2xl md:text-3xl text-brand-orange/60 pb-4 md:pb-5" data-id="element-373">
        :
      </span>
      <Unit value={timeLeft.minutes} label="Min" data-id="element-374" />
      <span className="font-display text-2xl md:text-3xl text-brand-orange/60 pb-4 md:pb-5" data-id="element-375">
        :
      </span>
      <Unit value={timeLeft.seconds} label="Seg" data-id="element-376" />
    </div>;
}